import { FunctionComponent } from "react";
import { selectPlan } from "@store/plan/planReducer";
import { useAppSelector } from "@store/store";
import { TabButton } from "@ui-kit/TabButton/TabButton";
import { OnboardingStepProps } from "../OnboardingScreens/OnboardingStepProps";
import { useTranslation } from "react-i18next";
import { Text } from "@ui-kit/Text/Text";
import { Category } from "../../entities/Category/Category";
import { Image } from "@ui-kit/Image/Image";
import { ExternalIcon } from "@icons/ExternalIcon";
import { colors } from "@ui-kit/ConfigProvider/ConfigProvider";
import { AddRemoveButton } from "../../components/buttons/AddRemoveButton/AddRemoveButton";

const FeaturedItem: FunctionComponent<Required<OnboardingStepProps>> = ({
  onClose,
  entity,
}) => {
  const { t } = useTranslation();
  const plan = useAppSelector(selectPlan);

  if (!entity) {
    return null;
  }

  return (
    <div className="featured-item">
      <div className="title-description">
        <Text variant="fontHeadingXlarge" className="center-text">
          {plan
            ? t("screens.onboarding.featuredItemTitleWithPlan")
            : t("screens.onboarding.featuredItemTitleWithoutPlan")}
        </Text>

        <Text variant="fontBodyLarge" className="center-text">
          {t("screens.onboarding.featuredItemDescription")}
        </Text>
      </div>
      <div className="card">
        <div className="card-image">
          <div className="card-image-overlay">
            <AddRemoveButton id={entity.id} type={"Place"} glow={true} />
          </div>
          <Image src={entity.coverPhotoUrl} alt={entity.name} />
        </div>
        <div className="card-content">
          <Text variant="fontHeadingXsmall">{entity.name}</Text>
          <div className="secondary">
            <Category entity={entity} />
            <Text variant="fontBodyMedium" color={colors.neutral600}>
              •
            </Text>
            <div className="distance">
              <ExternalIcon svgName="car" size={14} color={colors.neutral600} />
              <Text variant="fontBodyMedium" color={colors.neutral600}>
                2 mi
              </Text>
            </div>
          </div>
        </div>
      </div>
      <div className="actions">
        <TabButton
          variant="primary"
          wide={true}
          label={plan ? t("common.letsGo") : t("common.okay")}
          onPress={onClose}
        />
      </div>
    </div>
  );
};

export { FeaturedItem };
